import api from '../api';

export const SUBJECTS_REQUEST = 'SUBJECTS_REQUEST';
export const SUBJECTS_SUCCESS = 'SUBJECTS_SUCCESS';
export const SUBJECTS_FAILURE = 'SUBJECTS_FAILURE';

const subjectsRequest = () => ({
  type: SUBJECTS_REQUEST,
});

const subjectsSuccess = payload => ({
  type: SUBJECTS_SUCCESS,
  payload,
});

const subjectsFailure = payload => ({
  type: SUBJECTS_FAILURE,
  payload,
});

export const subjectsFetch = () => async (dispatch, getState) => {
  const { expired } = getState().assistance.subjects;
  if (expired > Date.now()) return;
  dispatch(subjectsRequest());
  try {
    const res = await api('cabinet/assistance/subjects', 'get');
    dispatch(subjectsSuccess(res.data));
  } catch (error) {
    dispatch(subjectsFailure({ err: 'Запрос тем обращений не удался' }));
  }
};
